<script setup>
import { computed, ref } from "vue"
import axios from "axios";
import {Field, Form} from 'vee-validate';
import ValidationService from "@/services/ValidationService"
import SaveInfo from "@/components/Base/SaveInfo.vue";

const project = ref({
  tagline: '',
  logline: '',
	user: '/api/users/' + window.currentUserId
})

const isDataUpdating = ref(false)
const isSubmitted = ref(false);
const isLoading = ref(false);

const projectId = computed(() => {
  return window.projectId
})


async function getProject() {
  if (window.projectId?.length > 0) {
    isLoading.value = true;
    try {
      const response = await axios.get('/api/projects/' + window.projectId);
      project.value = response.data;
	    project.value.user = '/api/users/' + window.currentUserId
    } catch (error) {
      console.log(error);
    }
    isLoading.value = false;
  }
}
getProject();

async function saveData() {
  if (projectId.value.length > 0) {
    isDataUpdating.value = true;
    const response = await axios.patch('/api/projects/' + projectId.value, project.value, {
      headers: {
        'Content-Type': "application/merge-patch+json"
      }
    }).catch((event) => {
      alert(event.response.data['hydra:description']);
    })
    isDataUpdating.value = false;
  }
}

async function createProjectInfo(projectId) {
  await axios.post('/api/projects_infos', {
    project: '/api/projects/' + projectId,
    competition: '/api/competitions/130',
    category: '/api/categories/142',
    tour: 0
  })
}

async function sumbitForm() {
  isLoading.value = true;
  const projectResponse = await axios.post('/api/projects', project.value);
  await createProjectInfo(projectResponse.data.id)
  window.location.reload();

}

function isRequired(val) {
  return ValidationService.isRequired(val);
}

function getFieldNameByIndex(index) {
  let res = '';
  if (index === 'tagline') {
    res = 'Ссылка на шоурил';
  } else if (index === 'logline') {
    res = 'Ссылка на фильмографию/портфолио';
  }
  return res;
}
</script>

<template>
  <div>
    <SaveInfo
        :isDataUpdating="isDataUpdating"
    ></SaveInfo>
    <div class="columns">
      <div class="column">
        <h1 style="margin-bottom: 0;">Заявка на участие в «Питчинге Кинооператоров» в рамках
          «Московской международной недели кино»</h1>
      </div>
    </div>

    <template v-if="!isLoading">
      <div class="columns">
        <div class="column">
          <Form @submit="sumbitForm" v-slot="{errors}">
            <Field style="display: none" v-model="project.tagline" name="tagline" :rules="isRequired"></Field>
            <Field style="display: none" v-model="project.logline" name="logline" :rules="isRequired"></Field>
            <div class="errors-block"
                 v-if="errors && Object.keys(errors).length > 0">
              <b>Пожалуйста, заполните поля:</b>
              <ul>
                <li v-for="(error,index) in errors" :key="index">Поле "{{ getFieldNameByIndex(index) }}"
                  обязательно для заполнения
                </li>
              </ul>
            </div>


            <div class="field">
              <label class="req">Ссылка на шоурил (не более 2 минут)</label>
              <a-input
                  v-model:value="project.tagline"
                  @blur="saveData"
              />
            </div>

            <div class="field">
              <label class="req">Ссылка на фильмографию/портфолио</label>
              <a-input
                  v-model:value="project.logline"
                  @blur="saveData"
              />
            </div>

            <button v-if="projectId.length === 0" class="button2" type="submit">Отправить</button>
	          <div v-else>Заявка отправлена на конкурс</div>
          </Form>
        </div>
        <div class="column"></div>
      </div>
    </template>
    <a-spin v-else/>
  </div>
</template>

<style lang="scss" scoped>

</style>